import {TASKMANAGE} from 'Constants/ActionTypes';

const {
  GET_TASK_LIST_WORD_STRATEGY_ID_OPTIONS,
  GET_TASK_LIST_PHONE_OPTIONS,
  GET_TASK_LIST_STRATEGY_OPTIONS,
  GET_TASK_LIST_WORK_TIME_OPTIONS,
  SET_TASK_LIST_SEARCH_DATA,
  SET_TASK_LIST_TAB_ACTIVE_KEY,
  GET_TASK_LIST_LIST,
  SET_TASK_LIST_PAGE_STATUS,
  SET_TASK_LIST_EDIT_MODAL_DATA,
  TASK_LIST_EDIT_TASK,
  TASK_LIST_CONFIRM_PAUSE,
  TASK_LIST_START_UP,
  TASK_LIST_CONFIRM_CANCEL,
  TASK_LIST_COMFIRM_UPLOAD,
  TASK_LIST_COMFIRM_DELETCHECK,
  TASK_LIST_COMFIRM_DELET,
  CUSTOMIZE_SMG_TEMPLATES,
  GET_CUSTOMIZE_TASK_LIST,
  TASK_LIST_DEPT,
  GET_RANDOM_TOKEN,
  GET_LIST_TONE
} = TASKMANAGE;
// 通用前缀
const url = '/robot';

const actions = {
  // 任务管理-任务列表-话术名称下拉框
  getWordStrategyIdOptions() {
    return {
      type: GET_TASK_LIST_WORD_STRATEGY_ID_OPTIONS,
      payload: {
        request: {
          method: 'get',
          url: `${url}/strategy/select`,
        },
      },
    };
  },
  // 任务管理-任务列表-编辑弹框-主叫号码下拉框
  getPhoneOptions() {
    return {
      type: GET_TASK_LIST_PHONE_OPTIONS,
      payload: {
        request: {
          method: 'get',
          url: `${url}/phone/select`,
        },
      },
    };
  },
  // 任务管理-任务列表-编辑弹框-话术下拉框
  getStrategyOptions(data) {
    return {
      type: GET_TASK_LIST_STRATEGY_OPTIONS,
      payload: {
        request: {
          method: 'post',
          url: `${url}/strategy/selectByDeptId`,
          data,
        },
      },
    };
  },
  // 任务管理-任务列表-编辑弹框-工作时间下拉框
  getWorkTimeOptions() {
    return {
      type: GET_TASK_LIST_WORK_TIME_OPTIONS,
      payload: {
        request: {
          method: 'get',
          url: `${url}/worktime/all`,
        },
      },
    };
  },
  // 任务管理-任务列表-设置搜索条件
  setSearchData(data) {
    return {
      type: SET_TASK_LIST_SEARCH_DATA,
      data,
    };
  },
  // 任务管理-任务列表-设置tab的activeKey
  setTabActiveKey(data) {
    return {
      type: SET_TASK_LIST_TAB_ACTIVE_KEY,
      data,
    };
  },
  // 任务管理-任务列表-table
  getTableList(data) {
    return {
      type: GET_TASK_LIST_LIST,
      payload: {
        request: {
          method: 'post',
          url: `${url}/task/list`,
          data,
        },
      },
    };
  },
  // 任务管理-任务列表-设置pageNum与pageSize
  setPageStatus(data) {
    return {
      type: SET_TASK_LIST_PAGE_STATUS,
      data,
    };
  },
  // 任务管理-任务列表-设置编辑弹框数据
  setEditModalData(data) {
    return {
      type: SET_TASK_LIST_EDIT_MODAL_DATA,
      data,
    };
  },
  // 任务管理-任务列表-编辑弹框-点击确定
  editTask(data) {
    return {
      type: TASK_LIST_EDIT_TASK,
      payload: {
        request: {
          method: 'post',
          url: `${url}/task/upsert`,
          data,
        },
      },
    };
  },
  // 任务管理-任务列表-编辑弹框-点击确定
  queryDeptTree(vccId) {
    return {
      type: TASK_LIST_DEPT,
      payload: {
        request: {
          method: 'get',
          url: `/department/robot/queryTree?vccId=${vccId}`,
        },
      },
    };
  },
  // 任务管理-任务列表-确认暂停任务
  confirmPause(id) {
    return {
      type: TASK_LIST_CONFIRM_PAUSE,
      payload: {
        request: {
          method: 'get',
          url: `${url}/task/pause/${id}`,
        },
      },
    };
  },
  // 任务管理-任务列表-启动任务
  startUp(id) {
    return {
      type: TASK_LIST_START_UP,
      payload: {
        request: {
          method: 'get',
          url: `${url}/task/restart/${id}`,
        },
      },
    };
  },
  // 任务管理-任务列表-取消
  confirmCancel(id) {
    return {
      type: TASK_LIST_CONFIRM_CANCEL,
      payload: {
        request: {
          method: 'post',
          url: `${url}/task/cancel/${id}`,
        },
      },
    };
  },
  // 任务管理-任务列表-数据导入
  confirmUpload(data) {
    return {
      type: TASK_LIST_COMFIRM_UPLOAD,
      payload: {
        request: {
          method: 'post',
          url: `${url}/task/appendJob`,
          data,
        },
      },
    };
  },
  // 任务管理-任务列表-删除检测
  deletCheck(data) {
    return {
      type: TASK_LIST_COMFIRM_DELETCHECK,
      payload: {
        request: {
          method: 'post',
          url: `${url}/task/delCheck/${data}`,
          data,
        },
      },
    };
  },
  // 任务管理-任务列表-删除
  delet(data) {
    return {
      type: TASK_LIST_COMFIRM_DELET,
      payload: {
        request: {
          method: 'post',
          url: `${url}/task/del/${data}`,
          data,
        },
      },
    };
  },
  //  短信模板下拉选接口
  getCustomizeSmgTemplates() {
    return {
      type: CUSTOMIZE_SMG_TEMPLATES,
      payload: {
        request: {
          method: 'get',
          url: `${url}/customize/smg/templates`,
        },
      },
    };
  },
  // 任务管理-任务列表-table
  getCustomizeTableList(data) {
    return {
      type: GET_CUSTOMIZE_TASK_LIST,
      payload: {
        request: {
          method: 'post',
          url: `${url}/customize/task/list`,
          data,
        },
      },
    };
  },
  //随机token字符串
  getRandomToken(){
    return {
      type: GET_RANDOM_TOKEN,
      payload: {
        request: {
          method: 'get',
          url: `${url}/task/random/token`,
        },
      },
    };
  },
  //音色列表
  getTonelList(){
    return {
      type: GET_LIST_TONE,
      payload: {
        request: {
          method: 'get',
          url: `${url}/tts/select`,
        },
      },
    };
  }
};

export default actions;  
